<template>
  <PropertiesList
    list-title="أرشيف العقارات"
    :details-query="{ from: 'archive' }"
    :show-create-actions="false"
    :show-stats="false"
    :archived="true"
  />
</template>

<script>
import PropertiesList from './list.vue';

export default {
  name: 'PropertiesArchive',
  components: { PropertiesList },
};
</script>
